<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Toast',
})
</script>
<template>
  <div v-if="isShow">
    <div class="toast-mask" v-if="mask" :style="{ zIndex: zIndex }"></div>
    <div class="mod-message-wrapper" :style="{ zIndex: zIndex }">
      <div class="mod-message animation-show">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script setup name="Toast" lang="ts">
export interface ToastParams {
  title?: string;
  duration?: number;
  onClose?: () => void;
  mask?: boolean;
  zIndex?: number;
}
// imports
import { ref, onUnmounted } from "vue";

// props
// 组件没有定义props，通过方法传参

// emits
// 组件没有定义emits，使用回调函数

// refs
const isShow = ref(false);
const title = ref(""); // 弹窗Toast文案
const showTime = ref(2000); //自定义时间单位ms，默认2000
const mask = ref(false); //是否显示透明蒙层，防止触摸穿透
const zIndex = ref(999); //层级
let timer = null; // 计时器
let onCloseCallback = null; //吐司结束回调

// methods
const showInfo = (params: ToastParams) => {
  // 处理参数
  onCloseCallback = params.onClose || null;
  const paramShowTime = params.duration || 2000;
  title.value = params.title || "";
  mask.value = params.mask || mask.value;
  zIndex.value = params.zIndex || zIndex.value;
  showTime.value = paramShowTime;

  // 显示Toast
  isShow.value = true;

  // 清除之前的计时器
  if (timer) clearTimeout(timer);

  // 设置新的计时器
  timer = setTimeout(() => {
    isShow.value = false;
    if (onCloseCallback) onCloseCallback();
  }, showTime.value);
};

const hide = () => {
  if (timer) clearTimeout(timer);
  isShow.value = false;
};

// 组件卸载时清理
onUnmounted(() => {
  if (timer) clearTimeout(timer);
});

// 向外暴露方法
defineExpose({
  showInfo,
  hide,
});
</script>

<style lang="less" scoped>
@import "./Toast.less";
</style>
